import { Instagram, Facebook, Youtube, Mail, Phone } from "lucide-react";
import { useLang } from "@/i18n";

const socials = [
  { icon: Instagram, href: "https://www.instagram.com/arniveda.farm/", label: "Instagram", testId: "footer-instagram-link" },
  { icon: Facebook, href: "https://www.facebook.com/arniveda.farm", label: "Facebook", testId: "footer-facebook-link" },
  { icon: Youtube, href: "https://www.youtube.com/@arnivedafarm", label: "YouTube", testId: "footer-youtube-link" },
];

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="bg-ink pt-20 text-cream" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="flex flex-wrap items-center gap-6">
          <img src="/assets/logo.jpeg" alt="Arniveda logo" className="h-16 w-16 rounded-full object-cover ring-1 ring-cream/20" />
          <div>
            <p className="font-serif text-2xl font-semibold tracking-tight">Arniveda Farm Technologies LLP</p>
            <p className="text-xs uppercase tracking-[0.25em] text-mustard">Gaon se Ghar Tak · arniveda.farm</p>
          </div>
        </div>

        <p className="mt-14 select-none font-serif text-[16vw] font-medium uppercase leading-none tracking-tight text-cream/10 lg:text-[10rem]" aria-hidden="true">
          Arniveda
        </p>

        <div className="grid grid-cols-1 gap-10 border-t border-cream/10 py-12 sm:grid-cols-2 lg:grid-cols-4">
          <div data-testid="footer-producer-address">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-mustard">{t("footer.producedBy")}</p>
            <p className="mt-4 text-sm font-light leading-relaxed text-cream/70">
              Sira Shakti Aajivika Producer Group,<br />
              Mehagaon, Dabra (Pichhore),<br />
              Gwalior, Madhya Pradesh 475110
            </p>
            <p className="mt-3 text-xs uppercase tracking-[0.15em] text-cream/50">FSSAI Lic. No. 21426570001447</p>
          </div>
          <div data-testid="footer-marketer-address">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-mustard">{t("footer.marketedBy")}</p>
            <p className="mt-4 text-sm font-light leading-relaxed text-cream/70">
              Arniveda Farm Technologies LLP,<br />
              A 604, Elixer Mk City, New Sirol Road,<br />
              City Centre, Gwalior, Madhya Pradesh 474001
            </p>
            <p className="mt-3 text-xs uppercase tracking-[0.15em] text-cream/50">FSSAI Lic. No. 21426570001394</p>
          </div>
          <div data-testid="footer-contact">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-mustard">{t("footer.talkToUs")}</p>
            <a href="mailto:customers@arniveda.farm" className="mt-4 flex items-center gap-3 text-sm font-light text-cream/70 transition-colors hover:text-mustard" data-testid="footer-email-link">
              <Mail className="h-4 w-4" /> customers@arniveda.farm
            </a>
            <a href="tel:+917987140498" className="mt-3 flex items-center gap-3 text-sm font-light text-cream/70 transition-colors hover:text-mustard" data-testid="footer-phone-link">
              <Phone className="h-4 w-4" /> +91 79871 40498
            </a>
          </div>
          <div data-testid="footer-social">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-mustard">{t("footer.follow")}</p>
            <div className="mt-4 flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={s.testId}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-colors duration-300 hover:border-mustard hover:bg-mustard hover:text-ink"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
            <p className="mt-4 text-xs uppercase tracking-[0.15em] text-cream/50">@arniveda.farm · @arnivedafarm</p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-cream/10 py-6 text-xs uppercase tracking-[0.15em] text-cream/40">
          <p>© {new Date().getFullYear()} {t("footer.rights")}</p>
          <p>{t("footer.closing")}</p>
        </div>
      </div>
    </footer>
  );
}
